<template>
    <validation-observer #default="{ invalid }" ref="observer">
        <span class="display-none">{{ invalid }}</span>
        <b-form class="mt-4">
            <PlanInputContent
                title="C. Situația inițială actuală a activității solicitantului"
                warn="Această secțiune include, dar nu se limitează la:
                                        <ul>
                                            <li>o analiză a resurselor, competențelor și capacităților solicitantului;</li>
                                            <li>managementul și organizarea entității;</li>
                                            <li>problemele strategice și provocările cu care se confruntă organizația.</li>
                                        </ul>"
            >
                <template v-slot:body>
                    <div class="textarea">
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                        >
                            <b-form-textarea
                                v-model="form.situation"
                                rows="4"
                                max-rows="20"
                                :state="errors.length > 0 ? false : null"
                                :readonly="completed"
                                @input="$emit('unsavedChanges', !!form.situation.length)"
                            ></b-form-textarea>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                        <b-icon-pencil-square font-scale="1.2"></b-icon-pencil-square>
                    </div>
                </template>
            </PlanInputContent>
            <hr class="mt-5">
            <b-form-checkbox
                v-model="completed"
                switch
                size="lg"
                class="switch-box"
                :disabled="invalid"
                @change="completeForm()"
            >Informațiile sunt complete și corecte</b-form-checkbox>
        </b-form>
    </validation-observer>
</template>

<script>
    import { BForm, BFormInput, BFormCheckbox, BFormTextarea, BIconPencilSquare, BIconCheckCircleFill, BTable, BIconXCircleFill} from "bootstrap-vue";
    import PlanInputContent from '@/pages/Aplicatii/M3/M3Sketch/components/plan-afaceri/PlanInputContent'
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    require('@/helpers/validations/validations')
    export default {
        components: {
            BForm,
            BFormInput,
            PlanInputContent,
            BFormCheckbox,
            BFormTextarea,
            BIconPencilSquare,
            BIconCheckCircleFill,
            BTable,
            BIconXCircleFill,
            ValidationProvider,
            ValidationObserver
        },
        props: {
            situatieInitiala: null,
        },
        data() {
            return {
                completed: null,
                form: {
                    situation: null,
                },
                companyName: '',
            }
        },
        computed: {
            checks() {
                return this.$store.getters['checks/checks'];
            },
            allData() {
                return this.$store.getters['m3Sketch/allData']
            }
        },
        watch: {
            checks: {
                handler: function() {
                    this.completed = this.checks.planDeAfaceriSituatie;
                    if(this.completed)
                        this.$emit('formComplete')
                    else
                        this.$emit('formIncomplete')
                },
                deep: true,
                immediate: true
            },
            situatieInitiala: {
                handler() {
                    if(this.situatieInitiala){
                        this.form.situation = this.situatieInitiala.business_plan_initial_state
                    }
                },
                deep: true,
                immediate: true
            }
        },
        mounted() {
            this.companyName = JSON.parse(localStorage.getItem('currentM3Company')).name

            if(!this.form.situation){
                this.form.situation = 'Text autogenerat POC Sketch* - vă rugăm editați\n\n' +
                    'Compania '+this.companyName+' dispune de resurse umane specializate, competente în gestionarea proiectelor ' +
                    'finantate din fonduri europene (daca este cazul mentionati finantari anterioare). Compania detine ' +
                    'resurse materiale (asa cum reiese din... /....), financiare (informatii cu privire la cofinantare), ' +
                    'informaționale (dotari, IT, etc). Compania '+this.companyName+' se incadreaza in categoria '+ (this.allData ? this.allData.business_type : '---') +' managementul' +
                    ' companiei fiind asigurat de ... prin ... Principalele probleme cu care se confrunta compania ' +
                    this.companyName+' sunt lipsa de predictibilitate si restrictiile impuse de pandemia COVID-19, întreruperea ' +
                    'lanțurilor de aprovizionare care au produs pierderi importante de venituri. Productia a fost redusa ca ' +
                    'urmare a restrictiilor impuse / au fost suspendate serviciile/operațiunile după impunerea restricțiilor ' +
                    'de călătorie și a recomandărilor de distanțare socială și de telemuncă. Compania a demonstrat o ' +
                    'capacitate scăzută pentru a investi în servicii / produse separate pentru gestionarea pandemiilor, ' +
                    'deoarece acestea sunt evenimente cu probabilitate scăzută. Deși compania si-a actualizat planurile de ' +
                    'reziliență ca răspuns la pandemia de COVID-19, observăm diferențele de venituri, in scadere cu ' +
                    parseFloat(this.allData ? this.allData.turnover_difference : 0).toFixed(2) +
                    '%. O alta provocare cu care se confrunta compania este adaptarea serviciilor, produselor si/sau a ' +
                    'angajatilor la restrictiile impuse (migrarea catre mediul online) – digitalizarea produselor si ' +
                    'serviciilor. Compania a intocmit protocoale de răspuns în caz de incidente și de gestionarea crizei ' +
                    'provocate de COVID-19, pentru un răspuns eficace în eventualitatea unor astfel de evenimente. Primul ' +
                    'protocol stabilit și cea mai importantă prioritate a companiei '+this.companyName+' în timpul pandemiei de COVID-19 ' +
                    'a fost siguranța și bunăstarea angajaților săi. În consecință, compania s-a asigurat ca angajații sunt în ' +
                    'siguranță, si ca aceștia sunt disponibili pentru a-si îndeplini funcțiile oferind angajaților sprijinul necesar.'
            }

        },
        methods: {
            completeForm() {
                this.$refs.observer.validate().then((e) => {
                    if(!e) {
                        this.completed = false
                        this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                    } else{

                        this.formSend = {
                            business_plan_initial_state: {
                                business_plan_initial_state: this.form.situation,
                                checked: this.completed
                            }
                        }
                        this.$store.dispatch('m3Sketch/saveAllDataProjectPart', this.formSend)
                            .then((firstResponse) => {
                                this.$toast.success(firstResponse.data)
                            }).catch((xhr) => {
                                if (xhr.status === 422) {
                                    this.errors.record(xhr.responseJSON.errors);
                                }
                                this.$toast.error(xhr.response.data.message);
                            });
                    }
                })
                if(this.checks.planDeAfaceriSituatie !== this.completed)
                    this.$store.dispatch('checks/updateChecks', { name: 'planDeAfaceriSituatie', value: this.completed })
            },
        }
    }
</script>

<style scoped>
.textarea{
    position: relative;
}
.textarea >>> textarea{
    border: 2px solid #9da2b0;
    background: #f8f9f9;
    color: #515679;
}
.textarea >>> textarea:read-only{
    background: #e5fffb;
}
.textarea >>> textarea:focus{
    box-shadow: 0 0 0 0.2rem #cdfaee;
}
.textarea svg{
    position: absolute;
    top: 10px;
    right: 10px;
    color: #9da2b0;
}
.switch-box{
    text-align: right;
    margin-top: 25px;
}
.switch-box >>> input, .switch-box >>> label{
    cursor: pointer;
}
.switch-box >>> label{
    font-size: 14px !important;
    color: #38393c;
    line-height: 1.9 !important;
}
</style>
